<template lang="pug">
  .trace-shipment
    .panel.panel-default
      .panel-heading.panel-title Shipment Details
      .panel-body(v-if="shipment")
        dt Shipment Code
        dd
          router-link.kzcode-default(:to="{ name: 'shipment', params: { id: shipment.id } }") {{shipment.code}}
        dt(v-if="shipment.originLocation") Origin Location
          dd.normal {{shipment.originLocation.name}}
        dt(v-if="shipment.targetLocation") Target Location
          dd.normal {{shipment.targetLocation.name}}
        dt Created
        dd {{shipment.created | date}}
        dt(v-if="shipment.createdBy") Created By
          dd.normal {{shipment.createdBy.username}}
        dt Shipment Date
        dd(v-if="shipment.shipped") {{shipment.shipped | date}}
        em.text-muted(v-else) not shipped
        dt Expected Delivery
        dd(v-if="shipment.expectedDeliveryDate") {{shipment.expectedDeliveryDate | date}}
      .panel-body(v-else)
        em.text-muted no information
</template>

<script>
import { dateFilter } from '@/filters/filters'

export default {
  props: {
    shipment: {
      type: Object
    }
  },
  filters: {
    date: dateFilter
  }
}
</script>

<style lang="scss">
.trace-shipment {
  .normal {
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/trace/components/ShipmentDetails.vue